import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useActivityTemplatesQuery } from '~/queries';
import { ApiHelperSelectInput, ApiHelperSelectInputWrapperProps } from './ApiHelperSelectInput';

export const SelectRobotId: FC<ApiHelperSelectInputWrapperProps> = ({
  value,
  setValue,
  ...props
}) => {
  const { t } = useTranslation();

  const { data: robots = [], isLoading } = useActivityTemplatesQuery();
  const items = useMemo(
    () =>
      robots.map((robot) => ({
        label: robot.name,
        value: robot.id,
      })),
    [robots],
  );

  return (
    <ApiHelperSelectInput
      label={t('robot.choose')}
      items={items}
      onChange={(value) => setValue('task_package_id', value)}
      loading={isLoading}
      value={value}
      {...props}
    />
  );
};
